export class ClientModel {
    id: KnockoutObservable<number> = ko.observable(null);
    name: KnockoutObservable<string> = ko.observable(null);
    installed: KnockoutObservable<boolean> = ko.observable(false);
    
    url: KnockoutObservable<string> = ko.observable(null).extend({ 
        required: {
            onlyIf: () => this.installed() === true
        },
        pattern: {
            onlyIf: () => PRODUCTION === true,
            message: 'Url must start from "https\:\/\/',
            params: '^https\:\/\/\/*'
        }
    });
    
    secret: KnockoutObservable<string> = ko.observable(null).extend({
        required: {
            onlyIf: () => this.installed() === true
        }, 
        minLength: {
            params: 50,
            onlyIf: () => this.installed() === true
        } 
    });
}